if (!customElements.get('product-item-slider')) {
  class ProductItemSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (typeof Swiper === 'undefined') return;

      this.swiper = new Swiper(this, {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      });

      this.swiper.on('sliderMove', () => {
        this.handleImageLoading();
      });

    }

    // This method is called when the slide changes to ensure all images are displayed and loaded eagerly
    handleImageLoading() {
      let images = this.querySelectorAll('img.mobile-image.hidden');
      if(window.innerWidth >= 990){
        images = this.querySelectorAll('img.desktop-image.hidden');
      }
      images.forEach(image => {
        image.classList.remove('hidden');
        image.removeAttribute('loading');
      });
    }
  }
  customElements.define('product-item-slider', ProductItemSlider);
}
